import React, { useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import { deleteVehicles, getVehicles, updateVehicles } from "../../../MyApi/vehicles";
import LoadingSpinner from "../../../Components/UI/spinner";
import TableActions from "../../../Components/UI/table/TableActions";
import StatusBadge from "../../../Components/UI/statusBadge";
import VechileModal from "./vechilemodal";
import i18next from "i18next";
     
const Vehicles = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);

  const { data, isLoading, refetch, error } = useQuery("getVehicles", getVehicles);
  const vehicles = data?.data?.vehicles || [];

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setModalMode("add");
    setModalId(null);
  };

  const handleAddClick = () => {
    setModalMode("add");
    setModalId(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (id) => {
    setModalMode("edit");
    setModalId(id);
    setIsModalOpen(true);
  };

  const handleViewClick = (id) => {
    setModalMode("show");
    setModalId(id);
    setIsModalOpen(true);
  };

  const columnsVehicles = [
    { label: "معرف المركبة", accessor: "id" },
    { label: "الاسم",    render: (row) => (
        <div className="d-flex align-items-center gap-3">
          {row.icon !== null && <img src={row.icon} width={24} height={24} />}
          <div>
            <h6 className="font16">{row.name}</h6>
            <p>#{row.id}</p>
          </div>
        </div>
      ), },
    { label: "الوصف", accessor: "description" },

    {
      label: "الحالة",
      render: (row) => <StatusBadge status={row?.is_active ? "active" : ""} />,
    },
  
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleViewClick(row.id)}
          edit={() => handleEditClick(row.id)}
          deleteFn={deleteVehicles}
          mutationKey={["deleteVehicles"]}
          refetch={refetch}
          isLoading={isLoading}
          id={row.id}
          viewPermission={"view_vehicle"}
          editPermission={"update_vehicle"}
          deletePermission={"delete_vehicle"}
          togglePermission={"update_vehicle"}
          toggleMutationKey={"toggle-update-vehicle"}
          queryKey={"getVehicles"}
          toggleFn={(id, status) => updateVehicles({is_active: status, "_method": "PUT", lang: i18next.language}, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

 

  return (
    <>   <div>
      <HeaderBar
        title={"المركبات"}
        content={"إدارة أنواع المركبات المستخدمة في التوصيل."}
      />
      <DataTable
        title={"المركبات"}
        columns={columnsVehicles}
        data={vehicles}
        onAddClick={handleAddClick}
        actionLabel={"إضافة مركبات"}  
        isLoading={isLoading}
        createPermission={"create_vehicle"}
        error={error}
        onRetry={() => refetch()}
      />
    </div>
    <VechileModal
      isOpen={isModalOpen}
      toggle={toggleModal}
      refetch={refetch}
      modalMode={modalMode}
      modalId={modalId}
    />
    </>
 
  );
};

export default Vehicles;
